/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';

import { IAppConfig } from './core/config/app-config.interfaces';
import { APP_CONFIG } from './core/config/app-config.token';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  pendoEnabled: boolean = this.appConfig.pendo.enabled;

  constructor(@Inject(APP_CONFIG) private readonly appConfig: IAppConfig) {}
}
